import apiSportsEvents from '@/api/sports-events'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  addSportsEventAthletesStart:
    '[add sportsEvent Athletes] Create sportsEvent Athletes start',
  addSportsEventAthletesSuccess:
    '[add sportsEvent Athletes] Create sportsEvent Athletes success',
  addSportsEventAthletesFailure:
    '[add sportsEvent Athletes] Create sportsEvent Athletes failure',
}

export const actionTypes = {
  addSportsEventAthletes:
    '[add sportsEvent Athletes] Create sportsEvent Athletes',
}

const mutations = {
  [mutationTypes.addSportsEventAthletesStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.addSportsEventAthletesSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.addSportsEventAthletesFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.addSportsEventAthletes](context, {athlete, id}) {
    context.commit(mutationTypes.addSportsEventAthletesStart)
    return new Promise((resolve) => {
      apiSportsEvents
        .addSportsEventsAthletes(athlete, id)
        .then((response) => {
          context.commit(mutationTypes.addSportsEventAthletesSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.addSportsEventAthletesFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
